module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 156);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Heading = __webpack_require__(157);

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Heading2.default;

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Heading;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _size = __webpack_require__(158);

var _size2 = _interopRequireDefault(_size);

var _color = __webpack_require__(159);

var _color2 = _interopRequireDefault(_color);

var _weight = __webpack_require__(160);

var _weight2 = _interopRequireDefault(_weight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headingStyles = _extends({}, _size2.default, _color2.default, _weight2.default);
var cx = _bind2.default.bind(headingStyles);

/**
 * The heading component provides a quick way to style any title with a font
 * size from our typography scale, color from our color palette and HTML tag
 * of choice.
 */
function Heading(_ref) {
  var children = _ref.children,
      color = _ref.color,
      id = _ref.id,
      size = _ref.size,
      tag = _ref.tag,
      weight = _ref.weight;

  var headingProps = {
    className: cx(size, color, weight, tag),
    id: id
  };

  var CustomTag = tag;

  return _react2.default.createElement(
    CustomTag,
    headingProps,
    children
  );
}

Heading.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  color: _propTypes2.default.oneOf(['black', 'steel', 'slate', 'silver', 'smoke', 'darkSmoke', 'extraDarkSmoke', 'licorice', 'snow', 'darkSnow', 'extraDarkSnow', 'white']),
  id: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['mega', 'xxxxl', 'xxxl', 'xxl', 'xl', 'l', 'm', 's', 'xs', 'xxs']),
  tag: _propTypes2.default.oneOf(['div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired, // required to prevent miss-use of title hierarchy for SEO
  weight: _propTypes2.default.oneOf(['regular', 'semibold', 'bold'])
};

Heading.defaultProps = {
  size: 'l',
  color: 'black', // this should default to #darkest when included in styleguide
  weight: 'regular',
  tag: 'div'
};

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mega":"size__mega___3jyht fontSize-xxxl lineHeight-title breakPointS-fontSize-xxxxl breakPointM-fontSize-mega","xxxxl":"size__xxxxl___2Oo4a fontSize-xxl lineHeight-title breakPointS-fontSize-xxxl breakPointM-fontSize-xxxxl","xxxl":"size__xxxl___2Ok9K fontSize-xxl lineHeight-title breakPointM-fontSize-xxxl","xxl":"size__xxl___2M4oE fontSize-xl lineHeight-title breakPointM-fontSize-xxl","xl":"size__xl___8fWJ4 fontSize-l lineHeight-title breakPointM-fontSize-xl","l":"size__l___1ACfg fontSize-l lineHeight-title","m":"size__m___3PA5p fontSize-m lineHeight-title","s":"size__s___10toi fontSize-s lineHeight-title","xs":"size__xs___3uAkd fontSize-xs lineHeight-title","xxs":"size__xxs___1eGrR fontSize-xxs lineHeight-title"};

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"black":"color__black___2f0FY c-black","steel":"color__steel___GLivr c-steel","slate":"color__slate___2QNtV c-slate","silver":"color__silver___SQdt4 c-silver","smoke":"color__smoke___1donP c-smoke","darkSmoke":"color__darkSmoke___EMWmi c-smoke--d","extraDarkSmoke":"color__extraDarkSmoke___N7rNo c-smoke--xd","snow":"color__snow___trnRi c-snow","darkSnow":"color__darkSnow___1MI_7 c-snow--d","extraDarkSnow":"color__extraDarkSnow___3Hnvc c-snow--xd","licorice":"color__licorice___LJhyi c-licorice","white":"color__white___2-otW c-white"};

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"regular":"weight__regular___3ccQ- fontWeight-4","semibold":"weight__semibold___19uxy fontWeight-5","medium":"weight__medium___2falM fontWeight-5","bold":"weight__bold___hnlF6 fontWeight-6"};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("classnames/bind");

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-heading.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-heading.js
// module id = 1102
// module chunks = 168707334958949